<template>
    <NuxtErrorBoundary>
        <template #default>
            <slot />
        </template>
        <template #error="{ error }">
            <div
                class="rounded border border-red-400 bg-red-100 p-4 text-red-800"
            >
                <p><strong>Đã xảy ra lỗi:</strong> {{ error }}</p>
            </div>
        </template>
    </NuxtErrorBoundary>
</template>
